import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import {NavLink, withRouter} from "react-router-dom";
import {Container} from "react-bootstrap";
import Loader from "../../blocks/Loader";
import Breams from "../../blocks/Breams";
import apiPreshift from "../../../api/apiPreshift";
import QuestionStepper from "../../steppers/QuestionStepper";
import store from "../../../localStorage";
import {pageLoadManageActions as loader} from "../../../reducers/load";
import { errorNotify } from "../../../helpers/functions";
import TestTrainingTab from "../../screens/questions/TestTrainingTab";
import apiTestTrainings from "../../../api/apiTestTrainings";
import TestTrainingTable from "../../screens/questions/TestTrainingTable";
import QuestionsTrainingContainer from "./QuestionsTrainingContainer";
import TrainingResultTable from "../../screens/questions/TrainingResultTable";



class TestTrainingContainer  extends Component {   
    constructor(props) {
        super(props);
        this.state = {
           selectedTreaningType:null,
           loadedTests: null,
           isLoading:false,
           selectedQuestions:[],
           selectedMode:null,
           selectedTypeId : 1,
           viewResults:false,
           loadedResults:null
        };
        store.dispatch({type: "PAGE_LOADED", loadId: "test_trainings"});
        document.title = props.t("Trainings");        
    };

    componentDidUpdate(){        
        
    }

    selectTreaningType= (typeName)=>{        
        this.setState({ selectedTreaningType: typeName }, ()=>{this.updateCurrentTests()});
    }

    updateCurrentTests= ()=>{         
        switch(this.state.selectedTreaningType){
            case 'byAssignedTests':                
                this.getAssignedTest();
                this.setState({selectedTypeId:1});
                break;
            case 'byBaseTests':                
                this.getDefaultTest();
                this.setState({selectedTypeId:2});
                break;
            case 'bySpecialTests':
                this.getSpecialTest();
                this.setState({selectedTypeId:2});
                break;
            default:                
                break;
        }
    }

     getSpecialTest = async () => {
        return new Promise((resolve, reject) => {
            loader.start('test_trainings');
            this.setState({ isLoading: true });

            apiTestTrainings
                .getSpecialTest()
                .then((result) => {
                    const raw = result?.data?.data ?? [];

                    const tests = raw.reduce((acc, item) => {
                        if (!item?.uuid) return acc;

                        acc[item.uuid] = {
                            uuid: item.uuid,
                            title: item.title ?? '',
                            enabled: item.active === true,
                            rules: item.rules ?? null,
                            questions: Array.isArray(item.questionIds)
                                ? item.questionIds
                                : [],
                        };

                        return acc;
                    }, {});

                    this.setState({ loadedTests: tests });
                    resolve(tests);
                })
                .catch((error) => {
                    console.error('Не удалось загрузить спец. тесты:', error);
                    this.setState({ loadedTests: {} });
                    reject(error);
                })
                .finally(() => {
                    this.setState({ isLoading: false });
                    loader.stop('test_trainings');
                });
        });
    };
    handleViewResults = ()=>{        
        this.handleGetEmployeeResults().then(()=>{
            this.setState({viewResults:true});
        })
    }
    handleCloseResults = ()=>{
        this.setState({viewResults:false,loadedResults:null});
    }
    getDefaultTest= async () => {
            return new Promise((resolve,reject)=>{
                loader.start("test_trainings"); 
                this.setState({isLoading:true});
                apiTestTrainings.getDefaultTests().then((result)=>{
                    const tests = result?.data?.tests || [];
                    this.setState({loadedTests:tests});                    
                    resolve();
                }).finally(()=>{
                    this.setState({isLoading:false});
                });
            });
        }
    getAssignedTest = async ()=>{
        const user_uuid = this.props.user.data.uuid;
        return new Promise((resolve,reject)=>{
                loader.start("test_trainings"); 
                 this.setState({isLoading:true});
                apiTestTrainings.getAssignetTests(user_uuid).then((result)=>{
                    const tests = result?.data?.tests || [];
                    this.setState({loadedTests:tests});                    
                    resolve();
                }).finally(()=>{
                    this.setState({isLoading:false});
                });;
        });
    }
    
    handleSelectTests = (tests,  mode)=>{     

        const questions = tests.flatMap((test) =>
            (test.questions ?? []).map((question) => ({
                ...question,
                testKey: test.key,        // чтобы знать, из какого теста вопрос
                testTitle: test.title,
                questionID:question
            }))
        );

        this.setState({
            selectedQuestions: questions,
            selectedMode: mode,
        });
    }


    handleExit = ()=>{

    }

    handleGetEmployeeResults= async()=>{
        const user_id = this.props.user.data.id;
        return new Promise((resolve,reject)=>{
            loader.start("test_trainings"); 
            this.setState({isLoading:true});
            apiTestTrainings.getEmployeeResults(user_id).then((result)=>{
                const resultData = result?.data?.data || [];                
                this.setState({isLoading:false,loadedResults:resultData});
                resolve();
            });
        });
        
    }
    getmodeSettingsByMode=(mode)=>{
        
        const MODES = {
            SPRINT: 'sprint',
            MARATHON: 'marathon',
        };
        if(mode === MODES.SPRINT){ 
            return {
                        order: 'random',   // порядок вопросов
                        timeLimit: 600 ,          // ограничение по времени, секунды (null = без лимита)
                        questionsLimit: 20 ,     // ограничение по количеству задач (null = все)
                    }
        }

        if(mode === MODES.MARATHON)
        {
            return {
                        order: 'sequential',   // порядок вопросов
                        timeLimit: null ,          // ограничение по времени, секунды (null = без лимита)
                        questionsLimit: null ,     // ограничение по количеству задач (null = все)
                    }
        }
        
    }

    renderContent = () => {
        const {
            loadedTests,
            selectedMode,
            selectedQuestions,
            selectedTreaningType,
            selectedTypeId,
            viewResults
        } = this.state;
        if(viewResults){
            return (<TrainingResultTable
                results={this.state.loadedResults}
                handleGoBack = {this.handleCloseResults}
                {...this.props}
            ></TrainingResultTable>);
        }
        // 1. Если выбран режим и есть загруженные тесты — показываем контейнер вопросов
        if (loadedTests && selectedMode) {
            return (
                <QuestionsTrainingContainer
                    {...this.state}
                    {...this.props}
                    mode={selectedMode}
                    modeSettings= {this.getmodeSettingsByMode(selectedMode)}
                    handleExit = {this.handleExit}
                    questions={selectedQuestions}
                    employee={this.props.user.data.id}
                    trainingType={selectedTypeId}
                    trainingTypeName = {selectedTreaningType}
                />
            );
        }

        // 2. Если тип тренировки ещё не выбран — показываем таб выбора
        if (!selectedTreaningType) {
            return (
                <TestTrainingTab
                    {...this.state}
                    {...this.props}
                    selectTreaningType={this.selectTreaningType}
                    handleViewResults = {this.handleViewResults}
                />
            );
        }

        // 3. Тип выбран — показываем таблицу тестов
        return (
            <TestTrainingTable
                handleSelectTests={this.handleSelectTests}
                {...this.props}
                {...this.state}
            />
        );
    };

    render() {
        return (
            <Loader
                className="h-100"
                isLoading={this.state.isLoading}
                loadId="test_trainings"
                justifyContent="center"
            >
                {this.renderContent()}
            </Loader>
        );
    }
}
const mapStateToProps = (store) => {
    return {
        load: store.loadState,
        theme_name: store.appState.theme_name,
    }
};
export default connect(mapStateToProps)(withRouter(withTranslation()(TestTrainingContainer)));